import React, { useEffect, useState, useRef } from "react";
import urls from "../../../Utils/urls";
import "../../../css/applyLoan.css";
import Button from "../../ui/Button";
import OtpInput from "../../OtpInput/OtpInput";
import { getStorage, isEmpty, setStorage } from "../../../Utils/common";
import { useNavigate, Link } from "react-router-dom";
import { sendotpForLogin, verifyotpForLogin } from "../../../Utils/api";
import Alert from "../../ui/Alert";
import MobileInput from "../../OtpInput/MobileInput";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Helmet } from "react-helmet";
// import { trackGoogleConversion } from "../../../Utils/googleAds";

function Login() {
  const [otp, setOtp] = useState("");
  const [screen, setScreen] = useState("getOtp");
  const [seconds, setSeconds] = useState(0);
  const [mobile, setMobile] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [loading, setLoading] = useState(false);
  const [accept, setAccept] = useState(false);
  const [acceptError, setAcceptError] = useState("");
  const [message, setMessage] = useState({});
  const [response, setResponse] = useState({});
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const [showMore, setShowMore] = useState(false);
  // Bumped on every resend so the OTP field re-arms its SMS autofill listener.
  const [otpRequestId, setOtpRequestId] = useState(0);

  // Extract UTM parameters from URL
  const getUtmParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_term: params.get("utm_term") || "",
      utm_content: params.get("utm_content") || "",
    };
  };

  useEffect(() => {
    if (screen === "getOtp") return;
    const timer = setInterval(() => {
      setSeconds((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [screen, seconds]);

  const sendOtp = () => {
    if (mobile.length < 10) {
      setMobileError("The Mobile field must be at least 10 characters in length.");
      return;
    }
    if (!accept) {
      setAcceptError("Please check the checkbox to accept our terms and conditions");
      return;
    } else {
      setAcceptError("");
    }

    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = getUtmParams();

    const param = {
      mobile,
      event_name: "login",
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
    };

    setLoading(true);
    sendotpForLogin(param).then((resp) => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setResponse(resp?.data);
        setStorage("mobile", mobile);
        setStorage("cust_profile_id", resp?.data?.Data?.cust_profile_id);
        setScreen("otpScreen");
        setSeconds(30);
        setMessage({ type: "success", msg: resp?.data?.Message, place: "globle" });
      } else {
        setMobile("");
        setMessage({ type: "error", msg: resp?.data?.Message || "An error occurred" });
      }
    });
  };

  const resendOtp = () => {
    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = getUtmParams();

    const param = {
      profile_id: getStorage("cust_profile_id"),
      event_name: "resend_otp",
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
    };

    setLoading(true);
    sendotpForLogin(param).then((resp) => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setResponse(resp?.data);
        setSeconds(30);
        setOtp("");
        setOtpRequestId((prev) => prev + 1);
        setMessage({ type: "success", msg: resp?.data?.Message, place: "globle" });
      } else {
        setMobile("");
        setMessage({ type: "error", msg: resp?.data?.Message || "An error occurred" });
      }
    });
  };

  // `code` is passed when the OTP arrives via SMS autofill, so we verify the
  // fresh value instead of state that has not re-rendered yet. Button clicks
  // pass a click event, which falls back to the state value.
  const verifyOTP = async (code) => {
    const otpNumber = typeof code === "string" ? code : otp;
    if (otpNumber.length !== 6) {
      setMessage({ type: "error", msg: "Please enter 6 digits OTP" });
      return;
    }

    const param = {
      event_name: "otp_verify",
      profile_id: getStorage("cust_profile_id"),
      otp: otpNumber,
    };

    setLoading(true);
    try {
      const resp = await verifyotpForLogin(param);
      setLoading(false);

      if (resp?.data?.Status === 1) {
        // trackGoogleConversion();
        setResponse(resp?.data);
        setStorage("next_step", resp?.data?.Data?.next_step);
        setStorage("token", resp?.data?.Data?.app_login_token);
        setMessage({ type: "success", msg: resp?.data?.Message, place: "globle" });

        if (resp?.data?.Data?.eligibility_status === 1) {
          setStorage("eligibility", 1);
        } else {
          setStorage("eligibility", 0);
        }

        setTimeout(() => {
          if (getStorage("eligibility") === 1) {
            navigate("/my-dashboard/eligibility");
          } else {
            navigate("/my-dashboard");
          }
        }, 300);
      } else {
        setOtp("");
        setMessage({ type: "error", msg: resp?.data?.Message || "An error occurred" });
      }
    } catch (err) {
      setLoading(false);
      setMessage({ type: "error", msg: "Error verifying OTP" });
      console.error("OTP Verification Error:", err);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (screen === "getOtp") sendOtp();
      else verifyOTP();
    }
  };

  useEffect(() => {
    if (isEmpty(message)) return;
    const timer = setTimeout(() => {
      setMessage({});
    }, 5000);
    return () => clearTimeout(timer);
  }, [message]);

  return (
    <>
      <Helmet>
        <title>Apply for Instant Salary Loan Online | Salary Uncle</title>
        <meta
          property="og:title"
          content="Apply for Instant Salary Loan Online | Salary Uncle"
        />
        <meta
          name="description"
          content="Apply for a salary loan with just your mobile number. Quick, paperless process with instant OTP verification. Fast approvals & secure digital experience."
        />
        <meta
          property="og:description"
          content="Apply for a salary loan with just your mobile number. Quick, paperless process with instant OTP verification. Fast approvals & secure digital experience."
        />
        <link rel="canonical" href={`${urls.SITE_URL}/apply-now`}></link>
      </Helmet>

      <div className="ap-page">
        <div className="ap-inner">

          {/* LEFT INFO */}
          <div className="ap-left">
            <h1>Get up to <span>₹1,00,000</span> in just 10 minutes</h1>
            <p className="ap-left-desc">Apply with just your mobile number. Fully digital, paperless, and approved in minutes — built for salaried professionals like you.</p>

            <div className="ap-features">
              <div className="ap-feature">
                <div className="ap-feature-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
                </div>
                <div className="ap-feature-text">
                  <span className="ap-feature-t">10-Minute Approval</span>
                  <span className="ap-feature-d">AI-powered instant decision</span>
                </div>
              </div>
              <div className="ap-feature">
                <div className="ap-feature-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                </div>
                <div className="ap-feature-text">
                  <span className="ap-feature-t">Minimal Documentation</span>
                  <span className="ap-feature-d">Only Aadhaar, PAN & salary slip</span>
                </div>
              </div>
              <div className="ap-feature">
                <div className="ap-feature-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>
                </div>
                <div className="ap-feature-text">
                  <span className="ap-feature-t">100% Secure</span>
                  <span className="ap-feature-d">RBI-regulated NBFC, bank-grade encryption</span>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT FORM */}
          <div className="ap-right">
            <div className="ap-card">
              <Alert setMessage={setMessage} message={message} />

              <div className="ap-card-icon">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.6 3.41 2 2 0 0 1 3.58 1.23h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.78a16 16 0 0 0 6.29 6.29l1.06-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              </div>

              {screen === "getOtp" ? (
                <>
                  <h2>Apply for a Personal Loan</h2>
                  <p className="ap-card-sub">Enter your <strong>10-digit mobile number</strong> to get started</p>

                  <div className="otpBox">
                    <MobileInput
                      name="mobile"
                      otp={mobile}
                      setOtp={setMobile}
                      isDisable={false}
                      error={mobileError}
                      onKeyDown={handleKeyDown}
                    />
                  </div>

                  <div className="ap-consent">
                    <input
                      name="radio"
                      type="checkbox"
                      checked={accept}
                      onChange={() => {
                        setAccept(!accept);
                        setAcceptError("");
                      }}
                    />
                    <p>
                      I give my consent for Salary Uncle to reach out to me through phone calls..
                      {showMore ? (
                        <span>
                          , text messages, WhatsApp, email, or the Salary Uncle mobile application, using the contact details I have shared. I confirm that I have carefully read and agree to the{" "}
                          <Link to="/terms-and-conditions">Terms &amp; Conditions</Link> and{" "}
                          <Link to="/privacy-policy">Privacy Policy</Link> of Salary Uncle.
                        </span>
                      ) : (
                        <button onClick={() => setShowMore(true)}> read more</button>
                      )}
                    </p>
                  </div>
                  {acceptError && <p className="ap-error">{acceptError}</p>}

                  <div className="button">
                    <Button title="Get OTP" onClick={sendOtp} loading={loading} />
                  </div>

                  <div className="ap-card-foot">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    Your information is encrypted &amp; secure
                  </div>
                </>
              ) : (
                <>
                  <h2>Verify OTP</h2>
                  <p className="ap-card-sub">Please enter the OTP to unlock your next step.</p>

                  <div className="ap-otp-info">
                    <div className="ap-otp-info-label">MOBILE NUMBER</div>
                    <div className="ap-otp-info-num">******{mobile.slice(-4)}</div>
                  </div>

                  <div className="otpBox">
                    <OtpInput
                      type="text"
                      setOtp={setOtp}
                      otp={otp}
                      isDisable={false}
                      placeholder="Enter Your OTP"
                      onKeyDown={handleKeyDown}
                      onAutoFill={verifyOTP}
                      autoFillKey={otpRequestId}
                      inputRefs={inputRefs}
                    />
                  </div>

                  <div className="button">
                    <Button title="Verify OTP" onClick={verifyOTP} loading={loading} />
                  </div>

                  <div className="ap-resend">
                    {seconds > 0 ? (
                      <p>
                        Didn't receive the OTP?{" "}
                        <FontAwesomeIcon icon={faClock} style={{ marginRight: "5px", marginLeft: "5px", color: "#509540" }} />{" "}
                        <span className="ap-resend-timer">00:{seconds}s</span>
                      </p>
                    ) : (
                      <button className="ap-resend-btn" onClick={!loading ? resendOtp : () => {}}>
                        Resend OTP
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default Login;
